<template>
  <div class="portal-screen">
    <title-screen title="10"></title-screen>
    <div><el-row><el-button class="float-right" style="margin-top: -40px" @click="$router.go(-1)">戻る</el-button></el-row></div>
    <ul class="block-menu flex flex-bet mt2">
      <li class="block-menu-item col2">
        <router-link to="/stationTax">
          <figure class="block-menu-item-img">
            <img class="fit-img" src="@/images/top/10秒で分かる相続税.png" alt="10秒でわかる相続税">
            <div class="block-menu-item-img-hover gtm_subtop_byoudewakaru_t" v-show="!isMobile">
              <div class="block-menu-item-img-hover-label gtm_subtop_byoudewakaru_t">詳しく見る<i class="fas fa-chevron-right"></i></div>
            </div>
<!--            <div class="block-menu-item-img-tab">新規</div>-->
          </figure>
          <div class="block-menu-item-cnt gtm_subtop_byoudewakaru_t">
            <div class="block-menu-item-cnt-title gtm_subtop_byoudewakaru_t">10秒でわかる相続税</div>
            <p class="block-menu-item-cnt-text mt1 gtm_subtop_byoudewakaru_t">
              お住いの最寄駅を選択いただくだけで相続税額をお出しします。
            </p>
          </div>
        </router-link>
      </li>
      <li class="block-menu-item col2">
        <router-link to="/calculation/tax">
          <figure class="block-menu-item-img">
            <img class="fit-img" src="@/images/top/相続税かんたん計算.png" alt="相続税かんたん計算">
            <div class="block-menu-item-img-hover gtm_subtop_kantankeisan_t" v-show="!isMobile">
              <div class="block-menu-item-img-hover-label gtm_subtop_kantankeisan_t">詳しく見る<i class="fas fa-chevron-right"></i></div>
            </div>
<!--            <div class="block-menu-item-img-tab">新規</div>-->
          </figure>
          <div class="block-menu-item-cnt gtm_subtop_kantankeisan_t">
            <div class="block-menu-item-cnt-title gtm_subtop_kantankeisan_t">相続税かんたん計算</div>
            <p class="block-menu-item-cnt-text mt1 gtm_subtop_kantankeisan_t">
              資産情報を入力するだけで、相続税額を簡単に計算できます。
            </p>
          </div>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
  import { isMobile } from 'mobile-device-detect'
  import TitleScreen from '../../../../components/common/TitleScreen'
  export default {
    name: 'SearchTax',
    components: { TitleScreen },
    data () {
      return {
        isMobile: isMobile
      }
    },
    created () {
      window.scroll(0, 0)
    }
  }
</script>

<style scoped>
  @import "portal.css";
</style>
